import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from "@gemini/core";
import { ChevronLeftIcon, CloseIcon } from "@gemini/icons";
import { Button } from "@gemini/ui";
const IconMap = {
    back: ChevronLeftIcon,
    close: CloseIcon,
};
export const NavigationTopBar = ({ buttonLabel = "", closeIcon = "back", headline = "", additionalCTAs, navigateBack, }) => {
    const testId = "cdp-navigation-top-bar";
    return (_jsxs(Box, { position: "sticky", top: 0, height: "sizing.64", paddingVertical: "spacing.16", paddingHorizontal: "spacing.16", display: "flex", alignItems: "center", justifyContent: "space-between", zIndex: "zIndex.1", width: "100%", backgroundColor: "color.border.constant.white", borderBottomStyle: "solid", borderBottomWidth: "borderWidth.1", borderBottomColor: "color.border.subdued.default", testId: testId, children: [_jsx(Button, { onPress: navigateBack, icon: IconMap[closeIcon], variant: "tertiary", iconOnly: !buttonLabel ||
                    (closeIcon === "back"
                        ? {
                            "breakpoint.base": true,
                            "breakpoint.lg": false,
                        }
                        : true), size: "40", testId: `${testId}.CloseAction`, children: buttonLabel }), headline && (_jsx(Box, { typography: "typography.body.16.bold", color: "color.content.constant.black", children: headline })), additionalCTAs && (_jsx(Box, { typography: "typography.body.16.bold", color: "color.content.constant.black", children: additionalCTAs }))] }));
};
